import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import Modal from 'react-modal'; // <-- LÍNEA AÑADIDA

// Importaciones de componentes de Administración
import ContabilidadPage from './pages/Admin/ContabilidadPage';
import { AdminLogin } from './components/admin/AdminLogin';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { ServerManagement } from './components/admin/ServerManagement';
import { ClientManagement } from './components/admin/ClientManagement';
import { ExpenseManagement } from './components/admin/ExpenseManagement'; 
import { TicketManagement } from './components/admin/TicketManagement';
import { AnnouncementManagement } from './components/admin/AnnouncementManagement';
import { ActivityLogs } from './components/admin/ActivityLogs';
import { DashboardSummary } from './components/admin/DashboardSummary';

// Importaciones de componentes de Cliente
import ClientPanel from './components/client/ClientPanel';
import ClientLogin from './components/client/ClientLogin';
import toast, { Toaster } from 'react-hot-toast';

// --- CONFIGURACIÓN DEL MODAL ---
Modal.setAppElement('#root'); // <-- LÍNEA AÑADIDA

// Este componente "guardián" protege las rutas de cliente
const ProtectedClientRoute = () => {
  const { isAuthenticated, user, loading } = useAuth();
  const { clientHash } = useParams();

  if (loading) {
    return <div className="min-h-screen bg-slate-900 flex items-center justify-center"><div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div></div>;
  }

  if (isAuthenticated && user?.role === 'client' && user?.clientHash === clientHash) {
    return <ClientPanel />;
  }

  return <Navigate to={`/client/${clientHash}/login`} replace />;
};

// Componente para gestionar la redirección post-pago
const PaymentHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      if (queryParams.get('payment') === 'success') {
        toast.success('¡Pago completado con éxito!');
        const redirectUrl = localStorage.getItem('postPaymentRedirect');
        window.history.replaceState({}, document.title, location.pathname);
        if (redirectUrl) {
          localStorage.removeItem('postPaymentRedirect');
          navigate(redirectUrl, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      }
    }, [location, navigate]);

    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get('payment') !== 'success') {
      return <Home />;
    }

    return <div className="min-h-screen bg-slate-900 flex items-center justify-center text-white"><p>Procesando pago, un momento por favor...</p></div>;
};

// Componente "envoltorio" para el layout de admin
const AdminLayoutWrapper = () => {
  const location = useLocation();
  return <AdminDashboard key={location.pathname} />;
};

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Toaster position="bottom-right" toastOptions={{ duration: 4000 }} />
        <Router>
          <Routes>
            {/* --- Rutas Públicas y de Cliente --- */}
            <Route path="/" element={<PaymentHandler />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/client/:clientHash/login" element={<ClientLogin />} />
            <Route path="/client/:clientHash/panel" element={<ProtectedClientRoute />} />
            <Route path="/client/:clientHash" element={<Navigate to="login" replace />} />

            {/* --- Estructura de Rutas de Administrador --- */}
            <Route path="/admin" element={<AdminLayoutWrapper />}>
              <Route index element={<DashboardSummary />} />
              <Route path="servers" element={<ServerManagement />} />
              <Route path="clients" element={<ClientManagement />} />
              <Route path="accounting" element={<ContabilidadPage />} />
              <Route path="tickets" element={<TicketManagement />} />
              <Route path="announcements" element={<AnnouncementManagement />} />
              <Route path="logs" element={<ActivityLogs />} />
            </Route>

            <Route path="*" element={<div className="p-8 text-center text-white">Página no encontrada</div>} />
          </Routes>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

const Home = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-6 text-white">
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-4">Bienvenido a Lisa Server</h1>
      <p className="text-xl">Selecciona tu panel de acceso.</p>
      <div className="mt-8 flex justify-center space-x-4">
        <a href="/admin/login" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors">
          Acceso Administrador
        </a>
      </div>
    </div>
  </div>
);

export default App;